// Stage 5N-2C: small summary card used at the top of each list page
// (Pending / Approved / Rejected / Suspended). Pure presentational —
// the parent passes the value already formatted.
//
// Variant tones tint the icon chip so the operator can scan four cards
// at a glance: amber (pending), green (active), red (rejected), slate
// (suspended/neutral).

const TONE_STYLES = {
  amber:   { chip: 'bg-amber-50 text-amber-600',   ring: 'ring-amber-100' },
  blue:    { chip: 'bg-brand-50 text-brand-600',   ring: 'ring-brand-100' },
  green:   { chip: 'bg-emerald-50 text-emerald-600', ring: 'ring-emerald-100' },
  red:     { chip: 'bg-rose-50 text-rose-600',     ring: 'ring-rose-100' },
  slate:   { chip: 'bg-slate-100 text-slate-600',  ring: 'ring-slate-200' },
  gold:    { chip: 'bg-amber-50 text-amber-700',   ring: 'ring-amber-100' }
};

export default function StatCard({
  label,
  value,
  hint,
  icon,
  tone = 'slate'
}) {
  const t = TONE_STYLES[tone] || TONE_STYLES.slate;
  return (
    <div className={`bg-white rounded-xl border border-surface-200 p-4 flex items-center gap-3 ring-1 ${t.ring}`}>
      <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${t.chip} text-lg`}>
        {icon}
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-[11px] uppercase tracking-wider text-ink-500 font-semibold m-0">
          {label}
        </p>
        <p className="text-xl font-bold text-ink-900 m-0 leading-tight truncate">
          {value}
        </p>
        {hint ? (
          <p className="text-xs text-ink-500 m-0 truncate">{hint}</p>
        ) : null}
      </div>
    </div>
  );
}
